<template>
  <BaseButton :variant="variant" @click="$emit('click')" :disabled="disabled">
    <BaseIcon v-if="isShowIcon" icon-name="reject" :width="iconWidth" :height="iconHeight">
      <IconReject></IconReject>
    </BaseIcon>
    <slot></slot>
  </BaseButton>
</template>

<script>
import BaseIcon from '@/components/BaseIcon.vue';
import IconReject from '@/components/icon/IconReject.vue';
import buttonMixin from '@/mixins/button';

export default {
  mixins: [buttonMixin],
  components: {
    BaseIcon,
    IconReject,
  },
  props: {
    variant: { type: String, default: 'danger' },
  },
};
</script>
